import Pickr from "@simonwep/pickr";
import $ from "jquery";
import * as THREE from "three";
import {
  ChangeGlobalMorph,
  ConvertMorphValue,
  GetGroup,
  GetMesh,
  hideIcon,
  pergola,
  greenHouseConst,
  showIcon,
  triggerIconClick,
  theModel,
  changeShapeType,
  buildTheModel,
  showHotspotsForAccessory,
  hideAllAccessoryHotspots,
  removeAccessory,
  getAllowedHeaterForCurrentSize,
  isExtraDoubleDoorAllowed,
} from "../../../../../core/3d-configurator";
import {
  removeFromUrlSystemBySide,
  removeFromUrlSystemByType,
} from "../../../../../core/customFunctions/initiSubSystem";
import {
  state, SIZE_DATA, COLORS_DATA, ACCESSORIES_DATA, INSTALLATION_PRICE, ANCHORING_SERVICE_PRICE
} from "../../../../../core/settings";
import { louverConfig } from "../../../../../core/Meshconfig";
import { requestDelayedRender } from "../../../../../core/3d-scene";
import {
  deleteActiveClassFromContainerRadioType,
  groups,
  countryType,
  shapeType,
} from "./../../../interface.js";
import { refreshCartTotal } from "../../../../summary/summary-button/summaryButton";
import "./interfaceGroupInputs.scss";
import { generateRangeHTML } from "../interfaceGroupInputs/range/generateRange.js";

export const typesInputs = {
  countryType: "countryTypes",
  shapeType: "shapeTypes",
  size: "size",
  colorFrame: "colorFrame",
  accessories: "accessories",
  installation: "installation",
  summary: "summary",
};

export let stringNameRoofColor = null;
export let stringNameFrameColor = null;

const SHELF_KEYS = new Set(['woodShelf1Win', 'woodShelf3Win', 'plasticShelf1Win', 'plasticShelf3Win', 'aluminumShelf2Win', 'set2Shelves']);

function updateSizeRestrictedAccessories() {
  const allowed = getAllowedHeaterForCurrentSize();
  const palmaOk = allowed === 'palma';
  const phoenixOk = allowed === 'phoenix';
  const doubleDoorOk = isExtraDoubleDoorAllowed();
  const placedAccessories = pergola.getPlacedAccessories?.() ?? [];
  const hasShelfOnSideWall = placedAccessories.some(
    p => SHELF_KEYS.has(p.accessoryKey) && (p.zone === 'wallLeft' || p.zone === 'wallRight')
  );
  const veilOk = !hasShelfOnSideWall;

  $('[data-key="standHeater"]').toggleClass('type_interface_accessories__card--disabled', !palmaOk);
  $('[data-key="phoenixHeater"]').toggleClass('type_interface_accessories__card--disabled', !phoenixOk);
  $('[data-key="extraDoubleDoor"]').toggleClass('type_interface_accessories__card--disabled', !doubleDoorOk);
  $('[data-key="veil"]').toggleClass('type_interface_accessories__card--disabled', !veilOk);

  // Remove any incompatible placed accessories
  [
    { key: 'standHeater', ok: palmaOk },
    { key: 'phoenixHeater', ok: phoenixOk },
    { key: 'extraDoubleDoor', ok: doubleDoorOk },
    { key: 'veil', ok: veilOk },
  ].forEach(({ key, ok }) => {
    if (!ok && state.subAccessoriesUrl.has(key)) {
      removeAccessory(key);
      state.subAccessoriesUrl.delete(key);
      $(`[data-key="${key}"]`).removeClass('type_interface_accessories__card--selected');
    }
  });
}

export function updateTextParam(
  customSetting,
  context,
  electro = false,
  onlyText = false,
  subSystem = false,
  walls = false
) {
  const text = [];

  if (subSystem) {
    customSetting.subSystem?.forEach((option) => text.push(option));
  }
  if (electro) {
    customSetting.electro?.forEach((option) => {
      text.push(option);
    });
  }

  let displayText = "";

  if (text.length > 1) {
    displayText = text.join(", ");
    if (displayText.length > 15) {
      displayText = displayText.substring(0, 12) + "...";
    }
  } else {
    displayText = text.length === 1 ? text[0] : "-";
  }
  if (onlyText) {
    return displayText;
  }

  $(context)
    .closest(".interface__group")
    .find(".interface__group__head__param")
    .text(displayText);
}

export function applyFrameColor(hex) {
  if (!hex || !window.theModel) return;
  const isAluminum = hex.toLowerCase() === "#c8c8c8";
  window.theModel.traverse(o => {
    if (!o.isMesh || !o.material || !o.material.name.startsWith("Anodized")) return;
    o.material.color.set(hex);
    o.material.metalness = isAluminum ? 0.8 : 0;
    o.material.roughness = isAluminum ? 0.2 : 0.4;
    o.material.needsUpdate = true;
  });
  requestDelayedRender();
}

export function applyAllColors() {
  if (!pergola.theModel) return;

  pergola.theModel.traverse((o) => {
    if (!o.isMesh || !o.material) return;

    const mName = o.name;

    if (
      mName.includes("heater") || mName.includes("avatar") ||
      mName.includes("Generic") || mName.includes("fastening") ||
      mName.includes("lighting") || mName.includes("Obj_") ||
      mName.includes("logo") || mName.includes("logoPlane") || mName.includes("light_")
    ) {
      return;
    }

    // mesh name directly + ancestors
    let isLouverMesh = false;
    let isFrameMesh =
      mName.startsWith("post_") ||
      mName.startsWith("frame_") ||
      mName.startsWith("mid_beam_");

    let ancestor = o.parent;
    while (ancestor && !isLouverMesh && !isFrameMesh) {
      const aName = ancestor.name || '';
      if (aName.includes("Slimline") || aName.includes("Alpine") ||
        aName.includes("Suburban") || aName.includes("Translucent")) {
        isLouverMesh = true;
      }
      if (aName.startsWith("post_") || aName.startsWith("frame_") ||
        aName.startsWith("mid_beam_")) {
        isFrameMesh = true;
      }
      ancestor = ancestor.parent;
    }

    if (isLouverMesh && (mName.startsWith("Plane") || mName.startsWith("Cube"))) {
      if (o.material.name === 'white_translucent') {
        o.material.transparent = true;
        o.material.opacity = 0.45;
        o.material.depthWrite = false;
        o.material.needsUpdate = true;
        o.userData.translucent = true;
        return;
      }
      o.material = o.material.clone();
      o.material.color.set(state.colorRoof);
      o.material.needsUpdate = true;
    } else if (isFrameMesh) {
      o.material = o.material.clone();
      o.material.color.set(state.colorBody);
      o.material.needsUpdate = true;
    }
  });

  // Apply selected frame color to all meshes using the "Anodized" material
  if (window.theModel) {
    const _isAluminum = (state.colorBody || '').toLowerCase() === '#c8c8c8';
    window.theModel.traverse(o => {
      if (!o.isMesh || !o.material) return;
      if (o.material.name === "Anodized" || o.material.name === "Anodized.005" || o.material.name === "Anodized.004") {
        o.material = o.material.clone();
        o.material.color.set(state.colorBody);
        o.material.map = null;
        o.material.metalness = _isAluminum ? 0.70 : 0;
        o.material.roughness = _isAluminum ? 0.45 : 0.4;
        o.material.envMapIntensity = _isAluminum ? 0.6 : 1.0;
        o.material.polygonOffset = true;
        o.material.polygonOffsetFactor = -1;
        o.material.polygonOffsetUnits = -1;
        o.material.needsUpdate = true;
      } else if (o.material.name === 'metall_paint') {
        o.material = o.material.clone();
        o.material.color.set(state.colorBody);
        o.material.polygonOffset = true;
        o.material.polygonOffsetFactor = -1;
        o.material.polygonOffsetUnits = -1;
        o.material.needsUpdate = true;
      } else if (o.material.name === 'Rubber - Black' && o.material.color.r > 0.5) {
        o.material = o.material.clone();
        o.material.color.set(0x1d1d1d);
        // o.material.polygonOffset = true;
        // o.material.polygonOffsetFactor = -4;
        //  o.material.polygonOffsetUnits = -4;
        o.material.metalness = 0;
        o.material.roughness = 0.5;
        o.material.needsUpdate = true;
      }
    });
    requestDelayedRender();
  } else {
    console.warn('[applyAllColors] window.theModel not set yet');
  }
}


// export function updateHeaterVisibility(isHeaterOn) {
//   const isFixedToHouse = state.backWall;
//   const root = pergola.theModel.parent || pergola.theModel;
//   const visualHeight = getHeightMorph(state.height) * 3.0;
//   const halfLength = state.length / 2;
//   const halfWidth = state.width / 2;
//   const hasCentralPosts = ((state.roofType === 1) && (state.width >= 5.0 || state.length >= 4.0));


//   root.traverse((o) => {
//     if (o.name.includes("heater")) {
//       o.traverse(child => {
//         if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
//           const widthIdx = child.morphTargetDictionary['width'];
//           if (widthIdx !== undefined) child.morphTargetInfluences[widthIdx] = 0;
//           const lengthIdx = child.morphTargetDictionary['lenth'];
//           if (lengthIdx !== undefined) child.morphTargetInfluences[lengthIdx] = 0;
//           const widthWallIdx = child.morphTargetDictionary['width_wall'];
//           if (widthWallIdx !== undefined) child.morphTargetInfluences[widthWallIdx] = 0;
//           const lengthWallIdx = child.morphTargetDictionary['length_wall'];
//           if (lengthWallIdx !== undefined) child.morphTargetInfluences[lengthWallIdx] = 0;
//         }
//       });
//     }
//   });

//   root.traverse((o) => {
//     if (o.name.includes("wall_behind_heater") || o.name.includes("no_wall_heater")) {
//       o.visible = false;
//       o.traverse(child => { child.visible = false; });
//     }
//   });

//   const clonedHeaters = [];
//   root.traverse((o) => {
//     if (o.userData && o.userData.clonedHeater) {
//       clonedHeaters.push(o);
//     }
//   });
//   clonedHeaters.forEach(h => h.parent.remove(h));

//   if (isHeaterOn) {
//     const heaterName = isFixedToHouse ? "wall_behind_heater_black" : "no_wall_heater_black";
//     const zOffset = heaterName === "wall_behind_heater_black" ? 0.1 : -0.1;

//     root.traverse((o) => {
//       if (o.name === heaterName && !o.userData.clonedHeater) {
//         o.visible = true;
//         o.traverse(child => { child.visible = true; });

//         if (hasCentralPosts) {
//           o.position.y = visualHeight + 0.5;
//           o.position.z = -(halfLength - 0.18);
//           o.position.x = -(halfWidth / 2 + zOffset);

//           const heaterClone = o.clone();
//           heaterClone.userData.clonedHeater = true;
//           heaterClone.position.y = visualHeight + 0.5;
//           heaterClone.position.z = -(halfLength - 0.18);
//           heaterClone.position.x = halfWidth / 2 - zOffset;
//           heaterClone.visible = true;
//           heaterClone.traverse(child => { child.visible = true; });
//           o.parent.add(heaterClone);
//         } else {
//           o.position.y = visualHeight + 0.5;
//           o.position.z = -(halfLength + zOffset);
//           o.position.x = 0;
//         }
//       }
//     });
//   }
// }

export function buildSummaryContent() {
  const $summary = $('<div class="type_interface_summary"></div>');

  const formatPrice = (n) =>
    n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';

  const addRow = (label, value) => {
    $summary.append(`
      <div class="type_interface_summary__row">
        <span class="type_interface_summary__row-label">${label}</span>
        <span class="type_interface_summary__row-value">${value}</span>
      </div>
    `);
  };

  const addSection = (title) => {
    $summary.append(`<div class="type_interface_summary__section">${title}</div>`);
  };

  // Country + Shape
  addRow('Country', countryType[state.countryType]);
  addRow('Shape', shapeType[state.shapeType]);

  // Size — use XML-resolved price if available (accounts for Black/RAL color pricing)
  addSection('Size');
  const sizes = SIZE_DATA[state.shapeType];
  const s = sizes?.[state.sizeIndex] ?? sizes?.[0];
  if (s) {
    const sizePrice = state.resolvedModelPrice ?? s.price;
    addRow(`${s.width} x ${s.length} m`, formatPrice(sizePrice));
  }

  // Color — show surcharge (difference from Aluminium brut base; Black pricing is in model price above)
  addSection('Color');
  const colorEntry = COLORS_DATA.find(c => c.hex === state.colorBody) ?? COLORS_DATA[0];
  addRow(colorEntry.name, formatPrice(colorEntry.surcharge ?? 0));

  // Accessories (downpipes excluded)
  const selectedKeys = [...state.subAccessoriesUrl].filter(k => k !== 'downpipes');
  if (selectedKeys.length > 0) {
    addSection('Accessories');
    const allItems = ACCESSORIES_DATA.flatMap(section => section.items);

    // Count placements per accessory key (from 3D scene placements)
    const placementCounts = {};
    const placed = pergola.getPlacedAccessories?.() ?? [];
    placed.forEach(({ accessoryKey }) => {
      placementCounts[accessoryKey] = (placementCounts[accessoryKey] || 0) + 1;
    });

    const WINDOW_MODE_NAMES = {
      sideWindow: { 'manual-window': 'Manual Side Windows', 'auto-window': 'Automatic Side Window' },
      backWindow: { 'manual-window': 'Manual Rear Window', 'auto-window': 'Automatic Rear Windows' },
    };
    selectedKeys.forEach(key => {
      const item = allItems.find(i => i.key === key);
      if (!item) return;
      // Use placement count if available, otherwise 1
      const count = placementCounts[key] || 1;

      let displayName = item.name;
      // Use XML-resolved price (includes Avec Montage when installation selected); fall back to hardcoded
      let unitPrice = state.resolvedAccessoryPrices?.[key]
        ?? (Array.isArray(item.price) ? item.price[0] : item.price);

      // sideWindow and backWindow have mode-dependent name and price
      if (WINDOW_MODE_NAMES[key]) {
        const mode = state.windowModes?.[key] || 'manual-window';
        const isAuto = mode === 'auto-window';
        displayName = WINDOW_MODE_NAMES[key][mode] ?? item.name;
        unitPrice = state.resolvedAccessoryPrices?.[key]
          ?? (Array.isArray(item.price) ? item.price[isAuto ? 1 : 0] : item.price);
      }

      const label = count > 1 ? `${displayName} <span class="type_interface_summary__count">(x${count})</span>` : displayName;
      addRow(label, formatPrice(unitPrice * count));
    });
  }

  // Installation (Belgium only)
  if (state.countryType === 0) {
    const isSurface = state.anchorType === 'surface';
    const hasInstall = state.installation;
    if (hasInstall || isSurface) {
      addSection('Installation');
      if (hasInstall) {
        addRow('Fee', formatPrice(INSTALLATION_PRICE));
        if (!isSurface) addRow('Anchoring service', formatPrice(ANCHORING_SERVICE_PRICE));
      }
      if (isSurface) addRow('Fixations for hard surface', formatPrice(0));
    }
  }

  return $summary;
}

export function interfaceGroupInputsComponent(
  type,
  ranges,
  initValue = false,
  title
) {
  switch (type) {
    case typesInputs.countryType:
      const radioCountryTypeContent = $(`
                <form class="type_interface_radio-model">
                  <div class="type_interface_radio-model_item option">
                    <input data-value="0" class="type_interface_radio-model_option type_interface_radio-model_option--belgium" 
                        type="radio" id="belgium" name="fav_language" value="${countryType[0]}"
                        />
                    <label class="type_interface_radio-model_label" for="belgium">${countryType[0]}</label>
                  </div>

                  <div class="type_interface_radio-model_item option">
                    <input data-value="1" class="type_interface_radio-model_option type_interface_radio-model_option--france" 
                        type="radio" id="france" name="fav_language" value="${countryType[1]}"
                        />
                    <label class="type_interface_radio-model_label" for="france">${countryType[1]}</label>
                  </div>
                </form>`);

      const activeCountryTypeClass = "type_interface_radio-model_item--active";

      // //INIT MODEL
      radioCountryTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const type = +$(this).attr("data-value");

          if (state.countryType === type) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeCountryTypeClass);
          }
        });

      //#region HANDLE MODEL
      radioCountryTypeContent
        .find('.type_interface_radio-model_item')
        .on("click", function () {
          const input = $(this).find('input[type="radio"]');
          const newCountryType = +input.attr("data-value");
          if (state.countryType === newCountryType) return;

          state.countryType = newCountryType;
          input.prop("checked", true);

          radioCountryTypeContent
            .find(".type_interface_radio-model_item")
            .removeClass(activeCountryTypeClass);

          $(this).addClass(activeCountryTypeClass);

          $(this)
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text(input.val());

          pergola.update();

          // show/hide Installation group based on countryType
          $(`[data-group-type="${typesInputs.installation}"]`)
            .toggle(state.countryType === 0);

          refreshCartTotal();
        });
      //#endregion

      return radioCountryTypeContent;

    case typesInputs.shapeType:

      const shapeInfoLinks = {
        [greenHouseConst.shape.Straight]: "https://ma-serre-en-verre.shop/collections/modeles-daction",
        [greenHouseConst.shape.Sloping]: "https://ma-serre-en-verre.shop/collections/modeles-daction",
        [greenHouseConst.shape.ExtraHigh]: "https://ma-serre-en-verre.shop/collections/modeles-daction",
      };

      function buildShapeItem(shapeKey, imgSrc) {
        return `
          <div class="type_interface_radio-shapeTypes-model_item option" data-value="${shapeKey}">
            <label class="type_interface_radio-shapeTypes-model_item_label">
              <div class="image-container">
                <img src="${imgSrc}" alt="${greenHouseConst.shapeNames[shapeKey]}" class="color-image">
              </div>
              <input class="type_interface_electronic_option" type="radio" name="subsystem_option" value="${greenHouseConst.shapeNames[shapeKey]}">
              <button type="button" class="shape-info-btn" data-shape="${shapeKey}">
                <img src="public/img/icons/marevo-icon-info.svg" alt="info">
              </button>
            </label>
            <span>${greenHouseConst.shapeNames[shapeKey]}</span>
          </div>`;
      }

      const radioShapeTypeContent = $(`
      <form class="type_interface_radio-shapeTypes-model">
        ${buildShapeItem('Straight', 'public/img/marevo-menu-shape-straight.png')}
        ${buildShapeItem('Sloping', 'public/img/marevo-menu-shape-slopping.png')}
        ${buildShapeItem('ExtraHigh', 'public/img/marevo-menu-shape-extraHigh.png')}
      </form>`);

      const activeShapeTypeClass = "type_interface_radio-shapeTypes-model_item--active";

      // INIT
      radioShapeTypeContent.find('.type_interface_radio-shapeTypes-model_item').each(function () {
        const shapeKey = $(this).attr("data-value");
        const value = greenHouseConst.shape[shapeKey];
        if (state.shapeType === value) {
          $(this).addClass(activeShapeTypeClass);
          $(this).find('input').prop("checked", true);
        }
      });

      // HANDLE - louvre type change
      radioShapeTypeContent.find('.type_interface_radio-shapeTypes-model_item').on("click", function () {
        const shapeKey = $(this).attr("data-value");
        const newShapeType = greenHouseConst.shape[shapeKey] ?? 0;
        if (state.shapeType === newShapeType) return;

        state.shapeType = newShapeType;
        state.sizeIndex = 0;

        // Sync width/length to the first size of the new shape
        const newSizes = SIZE_DATA[newShapeType] ?? [];
        const firstSize = newSizes[0];
        if (firstSize) {
          state.width = firstSize.width;
          state.length = firstSize.length;
        }

        radioShapeTypeContent
          .find(".type_interface_radio-shapeTypes-model_item")
          .removeClass(activeShapeTypeClass);

        $(this).addClass(activeShapeTypeClass);

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text($(this).find('input').val());

        // Re-render the size list for the new shape type
        const $sizeGroup = $(`[data-group-type="${typesInputs.size}"]`);
        const $sizeInputs = $sizeGroup.find('.interface__group__inputs');
        $sizeInputs.empty();
        $sizeInputs.append(interfaceGroupInputsComponent(typesInputs.size));

        // Update the size group header param
        if (firstSize) {
          $sizeGroup.find('.interface__group__head__param')
            .text(`${firstSize.code} - ${firstSize.width} x ${firstSize.length}m`);
        }

        state.accessoryPlacements = [];
        state.subAccessoriesUrl.clear();
        state.subAccessoriesUrl.add('downpipes');
        window.dispatchEvent(new CustomEvent('accessoryPlaced', { detail: { key: null } }));

        changeShapeType(newShapeType);
        updateSizeRestrictedAccessories();
        window.dispatchEvent(new CustomEvent('modelSizeChanged'));
        refreshCartTotal();
      });

      // HANDLE - info popup
      radioShapeTypeContent.find('.shape-info-btn').on("click", function (e) {
        e.stopPropagation();

        const shapeKey = $(this).attr("data-shape");
        const link = shapeInfoLinks[greenHouseConst.shape[shapeKey]];
        const $group = $(this).closest('.interface__group');

        $group.find('.shape-info-popup').remove();

        const popup = $(`
          <div class="shape-info-popup">
            <a href="${link}" target="_blank" class="shape-info-popup__link">More details</a>
          </div>
        `);

        $group.append(popup);

        requestAnimationFrame(() => {
          const btnRect = this.getBoundingClientRect();
          const groupRect = $group[0].getBoundingClientRect();
          const popupW = popup.outerWidth();
          let left = btnRect.left - groupRect.left + btnRect.width / 2 - popupW / 2;
          left = Math.max(0, Math.min(left, groupRect.width - popupW));
          const top = btnRect.top - groupRect.top - popup.outerHeight() - 12;
          popup.css({ top, left });
        });

        // close on outside click
        $(document).one('click.shapePopup', (ev) => {
          if (!$(ev.target).closest('.shape-info-popup, .shape-info-btn').length) {
            $group.find('.shape-info-popup').remove();
          }
        });
      });

      return radioShapeTypeContent;

    case typesInputs.size: {
      const sizes = SIZE_DATA[state.shapeType] ?? [];
      const activeSizeClass = "type_interface_size_item--active";

      const sizeCards = sizes.map((s, i) => `
        <div class="type_interface_size_item option" data-index="${i}">
          <span class="type_interface_size_item_code">${s.code} - ${s.width} x ${s.length}m</span>
          <span class="type_interface_size_item_price">€${s.price.toLocaleString()}</span>
        </div>
      `).join("");

      const emptyMsg = sizes.length === 0
        ? `<p class="type_interface_size_empty">Sizes for this shape type are coming soon.</p>`
        : "";

      const sizeContent = $(`<form class="type_interface_size">${sizeCards}${emptyMsg}</form>`);

      // INIT - mark active
      sizeContent.find(".type_interface_size_item").each(function () {
        if (+$(this).attr("data-index") === state.sizeIndex) {
          $(this).addClass(activeSizeClass);
        }
      });

      // HANDLE - size selection
      sizeContent.find(".type_interface_size_item").on("click", function () {
        const index = +$(this).attr("data-index");
        if (state.sizeIndex === index) return;

        const shapeType = +state.shapeType;
        const shapeSizes = SIZE_DATA[shapeType];
        if (!shapeSizes || !shapeSizes[index]) return;

        const prevCode = shapeSizes[state.sizeIndex]?.code ?? '';
        const prevDigit = parseInt(prevCode[1], 10);

        state.sizeIndex = index;
        const selected = shapeSizes[index];
        state.width = selected.width;
        state.length = selected.length;

        sizeContent.find(".type_interface_size_item").removeClass(activeSizeClass);
        $(this).addClass(activeSizeClass);

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${selected.code} - ${selected.width} x ${selected.length}m`);

        // Reset all accessories when size changes - clear state then sync UI
        state.accessoryPlacements = [];
        state.subAccessoriesUrl.clear();
        state.subAccessoriesUrl.add('downpipes');
        window.dispatchEvent(new CustomEvent('accessoryPlaced', { detail: { key: null } }));

        const newDigit = parseInt(selected.code[1], 10);
        if (newDigit !== prevDigit) {
          // Different model needed - switch it, then sync pergola options
          changeShapeType(shapeType);
          pergola.update();
        } else {
          pergola.update();
          buildTheModel(theModel);
        }
        updateSizeRestrictedAccessories();
        window.dispatchEvent(new CustomEvent('modelSizeChanged'));
      });

      return sizeContent;
    }

    case typesInputs.colorFrame: {
      const frameActiveColorClass = "type_interface_frame-colors_item--active";
      const baseColors = COLORS_DATA.filter(color => color.base);
      const ralColors = COLORS_DATA.filter(color => !color.base);

      function buildBaseItem(color, i) {
        const idx = COLORS_DATA.indexOf(color);
        if (color.custom) {
          return `
            <div class="type_interface_frame-colors_item type_interface_frame-colors_item--custom" data-index="${idx}">
              <div class="type_interface_frame-colors_swatch">
                <img src="${color.img}" alt="Custom">
              </div>
              <div class="type_interface_frame-colors_custom-label">
                <span class="type_interface_frame-colors_name">${color.name}</span>
                <span class="type_interface_frame-colors_surcharge">+€${color.surcharge}</span>
              </div>
            </div>`;
        }
        const swatchInner = color.img
          ? `<img src="${color.img}" alt="${color.name}">`
          : ``;
        const swatchStyle = color.img ? `` : `style="background-color: ${color.hex};"`;
        return `
          <div class="type_interface_frame-colors_item" data-index="${idx}" data-hex="${color.hex}">
            <div class="type_interface_frame-colors_swatch" ${swatchStyle}>${swatchInner}</div>
            <span class="type_interface_frame-colors_name">${color.name}</span>
          </div>`;
      }

      function buildRalItem(color) {
        const idx = COLORS_DATA.indexOf(color);
        return `
          <div class="type_interface_frame-colors_item" data-index="${idx}" data-hex="${color.hex}">
            <div class="type_interface_frame-colors_swatch" style="background-color: ${color.hex};"></div>
            <span class="type_interface_frame-colors_name">${color.name}</span>
            <span class="type_interface_frame-colors_ral">RAL ${color.ral}</span>
          </div>`;
      }

      const frameColorContent = $(`
        <div class="type_interface_frame-colors">
          <div class="type_interface_frame-colors__base">
            ${baseColors.map(buildBaseItem).join("")}
          </div>
          <div class="type_interface_frame-colors__ral">
            ${ralColors.map(buildRalItem).join("")}
            <div class="type_interface_frame-colors_item type_interface_frame-colors_item--other-ral">
              <button type="button" class="other-ral-info-btn">
                <img src="public/img/icons/marevo-icon-info.svg" alt="info">
              </button>
              <div class="type_interface_frame-colors_swatch type_interface_frame-colors_swatch--other-ral">
                <img src="public/img/icons/marevo-icon-custom-color.svg" alt="Other RAL">
              </div>
              <span class="type_interface_frame-colors_name">Other RAL</span>
            </div>
          </div>
        </div>
      `);

      const $ralSection = frameColorContent.find(".type_interface_frame-colors__ral");

      // INIT active state
      frameColorContent.find(".type_interface_frame-colors_item[data-hex]").each(function () {
        if ($(this).attr("data-hex").toLowerCase() === state.colorBody.toLowerCase()) {
          $(this).addClass(frameActiveColorClass);
          const idx = +$(this).attr("data-index");
          const color = COLORS_DATA[idx];
          stringNameFrameColor = color.ral ? `${color.name}, RAL ${color.ral}` : color.name;
          // if active color === RAL color - show the RAL section on init
          if (color.ral) $ralSection.addClass("type_interface_frame-colors__ral--visible");
          setTimeout(() => {
            $(this).closest(".interface__group").find(".interface__group__head__param")
              .text(stringNameFrameColor);
          }, 400);
        }
      });

      // HANDLE base swatch click (Aluminum / Black)
      frameColorContent.find(".type_interface_frame-colors_item[data-hex]").on("click", function () {
        const idx = +$(this).attr("data-index");
        const color = COLORS_DATA[idx];
        if (!color.base) {
          // RAL color selected - keep RAL section open
        } else {
          $ralSection.removeClass("type_interface_frame-colors__ral--visible");
          frameColorContent.find(".type_interface_frame-colors_item--custom")
            .removeClass("type_interface_frame-colors_item--expanded");
        }

        state.colorBody = color.hex;
        stringNameFrameColor = color.ral ? `${color.name}, RAL ${color.ral}` : color.name;

        frameColorContent.find(".type_interface_frame-colors_item").removeClass(frameActiveColorClass);
        $(this).addClass(frameActiveColorClass);

        $(this).closest(".interface__group").find(".interface__group__head__param")
          .text(stringNameFrameColor);

        applyFrameColor(color.hex);
        pergola.update();

        if (state.colorBody === '#000000') {
          if ((state.downpipeMaterial ?? 'grey_plastic') === 'grey_plastic') state.downpipeMaterial = 'black_plastic';
        } else {
          state.downpipeMaterial = 'grey_plastic';
        }
        const dpPlacements = pergola.getPlacedAccessories?.()?.filter(p => p.accessoryKey === 'downpipes') ?? [];
        dpPlacements.forEach(p => pergola.applyAccessoryMeshVisibility({ key: 'downpipes' }, p.zone, p.spanIndex, true));
        window.portalGenerete?.();
        refreshCartTotal();
      });

      // HANDLE Custom click - toggle RAL section
      frameColorContent.find(".type_interface_frame-colors_item--custom").on("click", function () {
        const isExpanded = $ralSection.hasClass("type_interface_frame-colors__ral--visible");
        $ralSection.toggleClass("type_interface_frame-colors__ral--visible", !isExpanded);
        $(this).toggleClass("type_interface_frame-colors_item--expanded", !isExpanded);
      });

      // HANDLE Other RAL info button
      const $otherRalItem = frameColorContent.find(".type_interface_frame-colors_item--other-ral");

      function closeOtherRalPopup() {
        $('.other-ral-popup').remove();
        $otherRalItem.removeClass("type_interface_frame-colors_item--popup-open");
      }

      frameColorContent.find(".other-ral-info-btn").on("click", function (e) {
        e.stopPropagation();

        const alreadyOpen = $('.other-ral-popup').length > 0;
        closeOtherRalPopup();
        if (alreadyOpen) return;

        const $group = $(this).closest('.interface__group');

        const popup = $(`
          <div class="other-ral-popup">
            <button type="button" class="other-ral-popup__close">&#x2715;</button>
            <p class="other-ral-popup__text">Choose any other RAL color.<br>Our manager will help you with the final selection after the order is placed. <a href="#" target="_blank" class="other-ral-popup__link">Learn more</a></p>
          </div>
        `);

        $group.append(popup);
        $otherRalItem.addClass("type_interface_frame-colors_item--popup-open");

        requestAnimationFrame(() => {
          const btnRect = this.getBoundingClientRect();
          const groupRect = $group[0].getBoundingClientRect();
          // const top = "73%";
          const top = "67%";
          popup.css({ top, left: 0, right: 0 });
        });

        popup.find('.other-ral-popup__close').on('click', closeOtherRalPopup);

        $(document).one('click.otherRalPopup', (ev) => {
          if (!$(ev.target).closest('.other-ral-popup, .other-ral-info-btn').length) {
            closeOtherRalPopup();
          }
        });
      });

      // XH models are black-only - disable all non-black color options
      const XH_BLACK = '#000000';
      const isXHSelected = () => {
        const sizes = SIZE_DATA[state.shapeType];
        const entry = sizes?.[state.sizeIndex] ?? sizes?.[0];
        return (entry?.code ?? '').includes('XH');
      };

      const applyXHColorConstraint = () => {
        const xh = isXHSelected();
        frameColorContent.find('.type_interface_frame-colors_item').each(function () {
          const hex = ($(this).attr('data-hex') ?? '').toLowerCase();
          const isBlack = hex === XH_BLACK;
          const disable = xh && !isBlack;
          $(this).css({ 'pointer-events': disable ? 'none' : '', 'opacity': disable ? '0.5' : '' });
        });
        if (xh && state.colorBody.toLowerCase() !== XH_BLACK) {
          state.colorBody = XH_BLACK;
          applyFrameColor(XH_BLACK);
          frameColorContent.find('.type_interface_frame-colors_item').removeClass(frameActiveColorClass);
          frameColorContent.find('.type_interface_frame-colors_item[data-hex="' + XH_BLACK + '"]').addClass(frameActiveColorClass);
          frameColorContent.closest('.interface__group').find('.interface__group__head__param').text('Black');
          refreshCartTotal();
        }
      };

      applyXHColorConstraint();

      const onModelSizeChanged = () => applyXHColorConstraint();
      window.addEventListener('modelSizeChanged', onModelSizeChanged);
      frameColorContent.on('remove', () => window.removeEventListener('modelSizeChanged', onModelSizeChanged));

      return frameColorContent;
    }

    case typesInputs.accessories: {
      const selectedAccessories = new Set(state.subAccessoriesUrl);
      selectedAccessories.add('downpipes');

      const $accessoriesContent = $('<div class="type_interface_accessories"></div>');

      ACCESSORIES_DATA.forEach((section) => {
        const $section = $(`
          <div class="type_interface_accessories__section" data-section="${section.id}">
            <div class="type_interface_accessories__section-header">
              <span class="type_interface_accessories__section-title">${section.title}</span>
              <div class="type_interface_accessories__section-header-right">
                <span class="type_interface_accessories__section-param"></span>
                <button type="button" class="type_interface_accessories__section-toggle">
                  <img src="public/img/icons/marevo-icon-plus.svg" alt="expand" class="toggle-icon">
                </button>
              </div>
            </div>
            <div class="type_interface_accessories__section-body"></div>
          </div>
        `);

        const $body = $section.find('.type_interface_accessories__section-body');

        const allowedHeater = getAllowedHeaterForCurrentSize();
        const doubleDoorOk = isExtraDoubleDoorAllowed();
        section.items.forEach((item) => {
          const isSelected = selectedAccessories.has(item.key);
          const isHeater = item.key === 'standHeater' || item.key === 'phoenixHeater';
          const heaterAllowed = !isHeater || (
            (item.key === 'standHeater' && allowedHeater === 'palma') ||
            (item.key === 'phoenixHeater' && allowedHeater === 'phoenix')
          );
          const isDisabled = !heaterAllowed || (item.key === 'extraDoubleDoor' && !doubleDoorOk);
          const isHidden = item.key === 'downpipes';
          const $card = $(`
            <div class="type_interface_accessories__card${isSelected ? ' type_interface_accessories__card--selected' : ''}${isDisabled ? ' type_interface_accessories__card--disabled' : ''}" data-key="${item.key}"${isHidden ? ' style="display:none;"' : ''}>
              <div class="type_interface_accessories__card-img-wrap">
                <img src="${item.img}" alt="${item.name}" class="type_interface_accessories__card-img">
                <div class="type_interface_accessories__card-checkbox"></div>
              </div>
              <span class="type_interface_accessories__card-name">${item.name}</span>
              <span class="type_interface_accessories__card-price">€${item.price}</span>
            </div>
          `);
          $body.append($card);
        });

        // init section param for pre-selected items
        const selectedInSection = section.items.filter(i => selectedAccessories.has(i.key) && i.key !== 'downpipes').map(i => i.name);
        if (selectedInSection.length > 0) {
          const paramText = selectedInSection.join(', ');
          $section.find('.type_interface_accessories__section-param').text(
            paramText.length > 18 ? paramText.substring(0, 18) + '...' : paramText
          );
        }

        $accessoriesContent.append($section);
      });

      // init top-level header param
      const visibleSelectedCount = [...selectedAccessories].filter(k => k !== 'downpipes').length;
      if (visibleSelectedCount > 0) {
        $accessoriesContent
          .closest('.interface__group')
          .find('.interface__group__head__param')
          .text(`${visibleSelectedCount} selected`);
      }

      // HANDLE - section toggle
      $accessoriesContent.find('.type_interface_accessories__section-header').on('click', function () {
        const $section = $(this).closest('.type_interface_accessories__section');
        const $body = $section.find('.type_interface_accessories__section-body');
        const $icon = $(this).find('.toggle-icon');
        const isOpen = $section.hasClass('type_interface_accessories__section--open');

        $section.toggleClass('type_interface_accessories__section--open', !isOpen);
        $body.slideToggle(200);

        // swap icon between plus and minus
        $icon.attr('src', isOpen
          ? 'public/img/icons/marevo-icon-plus.svg'
          : 'public/img/icons/marevo-icon-minus.svg'
        );
      });


      // HANDLE - card select (checkbox toggle)
      $accessoriesContent.find('.type_interface_accessories__card').on('click', function () {
        if ($(this).hasClass('type_interface_accessories__card--disabled')) return;
        const key = $(this).attr('data-key');
        const $section = $(this).closest('.type_interface_accessories__section');
        const sectionId = $section.attr('data-section');
        const sectionData = ACCESSORIES_DATA.find(s => s.id === sectionId);
        const item = sectionData?.items.find(i => i.key === key);
        const isSelected = selectedAccessories.has(key);

        const typeId = item ? greenHouseConst[item.typeGroup]?.[item.typeKey] : undefined;
        void typeId;

        if (key === 'downpipes') return;

        // mosquitoDoor is incompatible with extraDoubleDoor - block selection
        if (!isSelected && key === 'mosquitoDoor' && selectedAccessories.has('extraDoubleDoor')) return;
        if (!isSelected && key === 'extraDoubleDoor' && selectedAccessories.has('mosquitoDoor')) {
          // deselect mosquitoDoor first
          selectedAccessories.delete('mosquitoDoor');
          $accessoriesContent.find('.type_interface_accessories__card[data-key="mosquitoDoor"]')
            .removeClass('type_interface_accessories__card--selected');
          removeAccessory('mosquitoDoor');
        }

        if (isSelected) {
          selectedAccessories.delete(key);
          $(this).removeClass('type_interface_accessories__card--selected');
          hideAllAccessoryHotspots();
          removeAccessory(key);
        } else {
          selectedAccessories.add(key);
          $(this).addClass('type_interface_accessories__card--selected');
          // Update state before showHotspotsForAccessory so that any synchronous
          state.subAccessoriesUrl = new Set(selectedAccessories);
          showHotspotsForAccessory(key);
        }

        state.subAccessoriesUrl = new Set(selectedAccessories);

        // ventilation popup
        const ICON_11_KEYS = new Set(['automateOpening', 'roofWindow', 'sideWindow', 'backWindow']);
        const anyIcon11Selected = [...selectedAccessories].some(k => ICON_11_KEYS.has(k));
        if (anyIcon11Selected) {
          showIcon(11, false);
        } else {
          hideIcon(11);
        }

        // organization popup
        const orgSection12 = ACCESSORIES_DATA.find(s => s.id === 'organization');
        const ICON_12_KEYS = new Set((orgSection12?.items ?? []).map(i => i.key));
        const anyIcon12Selected = [...selectedAccessories].some(k => ICON_12_KEYS.has(k));
        if (anyIcon12Selected) { showIcon(12, false); } else { hideIcon(12); }

        // others popup
        const otherSection13 = ACCESSORIES_DATA.find(s => s.id === 'other');
        const ICON_13_KEYS = new Set((otherSection13?.items ?? []).map(i => i.key));
        const anyIcon13Selected = [...selectedAccessories].some(k => ICON_13_KEYS.has(k));
        if (anyIcon13Selected) { showIcon(13, false); } else { hideIcon(13); }

        // update section param: list selected names in current section
        const selectedInSection = (sectionData?.items ?? [])
          .filter(i => selectedAccessories.has(i.key) && i.key !== 'downpipes')
          .map(i => i.name);
        const sectionParamText = selectedInSection.length > 0
          ? selectedInSection.join(', ').substring(0, 18) + (selectedInSection.join(', ').length > 18 ? '...' : '')
          : '';
        $section.find('.type_interface_accessories__section-param').text(sectionParamText);

        // top-level group header param: names in section order
        const allSelectedNames = ACCESSORIES_DATA
          .flatMap(sec => sec.items.filter(i => selectedAccessories.has(i.key) && i.key !== 'downpipes').map(i => i.name));
        const paramText = allSelectedNames.join(', ');
        $accessoriesContent
          .closest('.interface__group')
          .find('.interface__group__head__param')
          .text(paramText.length > 22 ? paramText.substring(0, 22) + '...' : paramText);

        updateSizeRestrictedAccessories();
      });

      const ICON_11_KEYS_EXT = new Set(['automateOpening', 'roofWindow', 'sideWindow', 'backWindow']);
      const syncAccessoryUI = () => {
        // re-sync the local Set from the source of truth
        selectedAccessories.clear();
        state.subAccessoriesUrl.forEach(k => selectedAccessories.add(k));

        $accessoriesContent.find('.type_interface_accessories__card[data-key]').each(function () {
          const k = $(this).data('key');
          $(this).toggleClass('type_interface_accessories__card--selected', selectedAccessories.has(k));
        });

        const anyIcon11 = [...selectedAccessories].some(k => ICON_11_KEYS_EXT.has(k));
        if (anyIcon11) { showIcon(11, false); } else { hideIcon(11); }

        const orgSectionExt = ACCESSORIES_DATA.find(s => s.id === 'organization');
        const ICON_12_KEYS_EXT = new Set((orgSectionExt?.items ?? []).map(i => i.key));
        const anyIcon12 = [...selectedAccessories].some(k => ICON_12_KEYS_EXT.has(k));
        if (anyIcon12) { showIcon(12, false); } else { hideIcon(12); }

        const otherSectionExt = ACCESSORIES_DATA.find(s => s.id === 'other');
        const ICON_13_KEYS_EXT = new Set((otherSectionExt?.items ?? []).map(i => i.key));
        const anyIcon13 = [...selectedAccessories].some(k => ICON_13_KEYS_EXT.has(k));
        if (anyIcon13) { showIcon(13, false); } else { hideIcon(13); }

        ACCESSORIES_DATA.forEach(section => {
          const $sec = $accessoriesContent.find(`.type_interface_accessories__section[data-section="${section.id}"]`);
          const names = section.items.filter(i => selectedAccessories.has(i.key) && i.key !== 'downpipes').map(i => i.name);
          const text = names.join(', ');
          $sec.find('.type_interface_accessories__section-param').text(
            text.length > 18 ? text.substring(0, 18) + '...' : text
          );
        });

        const allNames = ACCESSORIES_DATA
          .flatMap(sec => sec.items.filter(i => selectedAccessories.has(i.key) && i.key !== 'downpipes').map(i => i.name));
        const headerText = allNames.join(', ');
        $accessoriesContent.closest('.interface__group').find('.interface__group__head__param')
          .text(headerText.length > 22 ? headerText.substring(0, 22) + '...' : headerText);

        // Re-evaluate placement-dependent restrictions (e.g. veil blocked by side-wall shelves)
        updateSizeRestrictedAccessories();
      };

      window.addEventListener('accessoryPlaced', syncAccessoryUI);
      $accessoriesContent.on('remove', () => window.removeEventListener('accessoryPlaced', syncAccessoryUI));

      return $accessoriesContent;
    }

    case typesInputs.installation: {
      const activeInstallClass = "type_interface_installation__btn--active";

      const $installContent = $(`
        <div class="type_interface_installation">
          <div class="installation_group">
            <span class="installation_title">Anchor type:</span>
            <div class="installation_parameters" data-install-group="anchor">
              <button type="button" class="type_interface_installation__btn" data-value="ground">In the ground</button>
              <button type="button" class="type_interface_installation__btn" data-value="surface">Hard surface</button>
            </div>
          </div>

          <div class="installation_group">
            <span class="installation_title">Service d'installation</span>
            <div class="installation_parameters" data-install-group="service">
              <button type="button" class="type_interface_installation__btn" data-value="false">No</button>
              <button type="button" class="type_interface_installation__btn" data-value="true">Yes</button>
            </div>
          </div>
        </div>
      `);

      // INIT - activate the correct button in each group
      $installContent.find('[data-install-group="anchor"] .type_interface_installation__btn').each(function () {
        if ($(this).attr('data-value') === (state.anchorType ?? 'ground')) $(this).addClass(activeInstallClass);
      });
      $installContent.find('[data-install-group="service"] .type_interface_installation__btn').each(function () {
        const isActive = $(this).attr('data-value') === 'true' ? state.installation : !state.installation;
        if (isActive) $(this).addClass(activeInstallClass);
      });

      // HANDLE anchor type
      $installContent.find('[data-install-group="anchor"] .type_interface_installation__btn').on('click', function () {
        const val = $(this).attr('data-value');
        state.anchorType = val;
        $installContent.find('[data-install-group="anchor"] .type_interface_installation__btn').removeClass(activeInstallClass);
        $(this).addClass(activeInstallClass);
        refreshCartTotal();
      });

      // HANDLE service d'installation
      $installContent.find('[data-install-group="service"] .type_interface_installation__btn').on('click', function () {
        const val = $(this).attr('data-value') === 'true';
        state.installation = val;
        $installContent.find('[data-install-group="service"] .type_interface_installation__btn').removeClass(activeInstallClass);
        $(this).addClass(activeInstallClass);
        const label = val ? 'Yes' : 'No';
        $(this).closest('.interface__group').find('.interface__group__head__param').text(label);
        refreshCartTotal();
      });

      return $installContent;
    }

    case typesInputs.summary: {
      return buildSummaryContent();
    }

    default:
      return `< div > NON HTML</div > `;
  }
}